(function() {
    'use strict';

    angular
        .module('expenses')
        .controller('ExpensesController', ExpensesController);

    /* @ngInject */
    function ExpensesController($scope, $state, $uibModal, toastr, ExpensesService, Expense, expense, currencies, payees,  paymentMethods, bankAccounts, itemCategories, itemSemesters, itemCostCenters) {
        var vm = this;

        /* Bindable methods */
        vm.save = save;
        vm.remove = remove;
        vm.pay = pay;
        vm.reverse = reverse;
        
        /* View rendering */
        var view = {
            // TODO: consider extracting into directives/components
            renderers: { 
                'root.expenses.create': create, 
                'root.expenses.read': read, 
                'root.expenses.edit': edit, 
                'root.expenses.list': list 
            },
            init: () => view.renderers[$state.current.name](),
            refresh: () => {$state.go($state.current, $state.params, { reload: true })},
        };
        // TODO: find a better way to check current page
        view.currentMethod = view.renderers[$state.current.name].name;
        // TODO: remove vm.view from views then remove it from controler scope
        vm.view = view.currentMethod;     
        
        // Forms errors
        vm.form_error = false;
        vm.formItem_error = false;

        // Initializing view
        view.init();
        
        /* Implementation details */
        function create() {
            /* Model */
            vm.expense = expense || new Expense();
            vm.expense.recurringDueDates = [];
                            
            /* Bindables */
            vm.addItem = addItem;
            
            /* DOM */
            vm.recurring = false;
            vm.paid = false;
            vm.newItem = {};
            vm.newItem.semester = itemSemesters[itemSemesters.length-1];
            vm.nRecurrences = 1;
            /* FIXME: these errors shown in the console are really annoying but doesn't seem to impact end-user experince. 
                This seems to be a problem with the component itself:
                https://github.com/fragaria/angular-daterangepicker/pull/136
                */ 
            vm.optionsDueDatepicker = {
                format: "longDate",
                autoUpdateInput: true,
                singleDatePicker: true, 
                showDropdowns: true,
            };
            vm.optionspaymentDatepicker = {
                format: "longDate",
                autoUpdateInput: true,
                singleDatePicker: true, 
                showDropdowns: true,
                maxDate: moment()
            };

            /* Select choices */
            vm.currencies = currencies;
            vm.payees = payees;
            vm.paymentMethods = paymentMethods;
            vm.bankAccounts = [];

            angular.forEach(bankAccounts, function(value, key) {
                if(value.id == 179 || value.id == 180) {
                    vm.bankAccounts.push(value);
                }
            });

            vm.expensePayees = payees;
            vm.itemCategories = itemCategories;
            vm.itemSemesters = itemSemesters;
            vm.itemCostCenters = itemCostCenters;
            vm.editItem = editItem;

            // Decimal numbers mask
            // TODO: probably not needed anymore
            $scope.$watchCollection(
                () => [
                    vm.newItem.total,
                    vm.expense.additions,
                    vm.expense.discounts,
                ], 
                (newValue) => {
                    if (vm.newItem.total && vm.newItem.total.constructor === String) {
                        vm.newItem.total =  vm.newItem.total.replace(',', '.');
                    }

                    if (vm.expense.additions && vm.expense.additions.constructor === String) {
                        vm.expense.additions = vm.expense.additions.replace(',', '.');
                    }
                    
                    if (vm.expense.discounts && vm.expense.discounts.constructor === String) {
                        vm.expense.discounts = vm.expense.discounts.replace(',', '.');
                    }
                });

            // Recurring due dates
            if (view.currentMethod === 'create') {
                $scope.$watch(
                    () => vm.recurring, 
                    (newValue) => {
                        if (newValue == true) {
                            vm.expense.recurringDueDates = [];
                            generateRecurringDateFields(vm.nRecurrences = 1);
                        }
                    });
                $scope.$watch(
                    () => vm.nRecurrences, 
                    generateRecurringDateFields);
            }

            function generateRecurringDateFields(newQty) {
                newQty = parseInt(newQty);
                if(newQty > 0) {
                    if (newQty < vm.expense.recurringDueDates.length) {
                        vm.expense.recurringDueDates = vm.expense.recurringDueDates.splice(0, newQty);
                    }
                    else if (newQty > vm.expense.recurringDueDates.length) {
                        var qty = newQty - vm.expense.recurringDueDates.length;
                        
                        for (var i = 0; i < qty; i++) {
                            if(moment.isMoment(vm.expense.due_date)) {
                                var nextDate = new moment(vm.expense.due_date);
                                vm.expense.recurringDueDates.push(nextDate.add(vm.expense.recurringDueDates.length+1,'months'));
                            }
                            else {
                                vm.expense.recurringDueDates.push(null);
                            }
                        }
                    }
                }
            }

            function addItem(item) {
                if (!item 
                    || !item.account
                    || !item.description
                    || isNaN(Number(item.total))
                    || !item.semester
                    || !item.cost_center) {
                        vm.formItem_error = true;
                        return this;
                }
                else {
                    vm.formItem_error = false;
                    vm.newItem.semester = itemSemesters[itemSemesters.length-1];
                    vm.expense.addItem(item);
                    vm.newItem = {};
                }
            }

            function editItem (index, item) {
                vm.newItem = {
                    'account': item.account,
                    'description': item.description,
                    'total': item.total,
                    'semester': item.semester,
                    'cost_center': item.cost_center
                };
                vm.expense.removeItem(index);
            }
        }
        
        function read() {
            if (expense) {   
                vm.expense = new Expense(expense);
                // vm.expense.due_date = moment(vm.expense.due_date);
                vm.paid = !!vm.expense.payment_date || false;
            }
            else {
                vm.expense = null;
                vm.resultMessage = 'Sorry, this expense can not be found.';
            }
        }

        function edit() {
            create(); // TODO: extract 'form' from 'create'
            read();
        }

        function list() {
            /* Model Collection */
            vm.expenses = ExpensesService.expenses;

            /* QBO importing */
            vm.qboImporting = false; 
            vm.qboImport = qboImport;
                        
            /* Pagination */
            vm.pagination = {
                pageChanged: pageChanged,
                currentPage: ExpensesService.currentPage,
                totalItems: ExpensesService.totalItems,
                to: ExpensesService.to,
                itemsPerPage: ExpensesService.itemsPerPage,
            }
            
            // TODO: keep filters persisted when params.filters is set
            /* Filters */
            const statusEnum = {
                NOTPAID: 0,        
                PAID: 1,
            };
            $state.params.filters = $state.params.filters || {};
            vm.filter = {
                apply: applyFilter,
                clear: clearFilter,
                status: {
                    choices:  [
                        { 
                            id: statusEnum.NOTPAID,
                            name: 'Not paid'
                        },
                        { 
                            id: statusEnum.PAID, 
                            name: 'Paid' 
                        }, 
                    ],
                    selected: $state.params.filters.status, // TODO: turn into boolean
                },
                cost_center: {
                    choices: itemCostCenters,
                    selected: $state.params.filters.cost_center_id,
                },
                payee: {
                    choices: payees,
                    selected: $state.params.filters.payee_id,
                },
                due_date: null,
                payment_date: null,
                query: {},
            };

            /* Bulk actions menu */
            const bulkActionsEnum = {
                PAY: 0,
                REVERSE: 1,
                DELETE: 2,
            };
            vm.bulkActions = {
                apply: applyBulkAction,
                toggleCheckBox,
                checkedAll: false,
                choices: [
                    {
                        id: bulkActionsEnum.PAY, 
                        name: 'Pay'
                    }, 
                    {   
                        id: bulkActionsEnum.REVERSE, 
                        name:'Reverse'
                    },
                    {   
                        id: bulkActionsEnum.DELETE, 
                        name:'Delete'
                    }
                ],
                selected: null,
            };

            /* No results */
            if (!vm.expenses || !vm.expenses.length) {   
                vm.resultMessage = 'Sorry, no results were found!';
            }
    
            /* Implementation details */
            function applyFilter() {
                vm.filter.query = {};

                if (vm.filter) {
                    if (vm.filter.due_date && vm.filter.due_date.startDate && vm.filter.due_date.endDate) {
                        vm.filter.query.due_date_start = moment(vm.filter.due_date.startDate).format('YYYY-MM-DD 00:00:00');
                        vm.filter.query.due_date_end = moment(vm.filter.due_date.endDate).format('YYYY-MM-DD 23:59:59');
                    }

                    if (vm.filter.payment_date && vm.filter.payment_date.startDate && vm.filter.payment_date.endDate) {
                        vm.filter.query.payment_date_start = moment(vm.filter.payment_date.startDate).format('YYYY-MM-DD 00:00:00');
                        vm.filter.query.payment_date_end = moment(vm.filter.payment_date.endDate).format('YYYY-MM-DD 23:59:59');
                    }

                    if (vm.filter.payee.selected) {
                        vm.filter.query.payee_id = vm.filter.payee.selected.id;
                    }

                    if (vm.filter.cost_center.selected) {
                        vm.filter.query.cost_center_id = vm.filter.cost_center.selected.id;
                    }

                    switch (vm.filter.status.selected && vm.filter.status.selected.id) {
                        case statusEnum.PAID:
                            vm.filter.query.status = 'paid' 
                            break;
                        case statusEnum.NOTPAID:
                            vm.filter.query.status = 'not paid' 
                            break;
                        default:
                            // do nothing;
                            break;
                    }
                }

                vm.filter.currentPage = 1;
                $state.params.filters = vm.filter.query;
                view.refresh()
            }

            function clearFilter() {
                /* FIXME: impossible to select the same date range right after clearing.
                    This seems to be a problem with the component itself:
                    https://github.com/fragaria/angular-daterangepicker/issues/82
                    */ 
                vm.filter.due_date = {};
                vm.filter.payment_date = { startDate: null, endDate: null };
                vm.filter.payee.selected = null;
                vm.filter.cost_center.selected = null;
                vm.filter.status.selected = null;
            }

            function pageChanged () {
                $state.params.filters = $state.params.filters || {};
                $state.params.filters['page'] = vm.pagination.currentPage || 1;
                view.refresh();
            }

            function toggleCheckBox(index) {
                if (index === undefined) {
                    vm.bulkActions.checkedAll = !vm.bulkActions.checkedAll;

                    for (var expense of vm.expenses) {
                        expense.checked = vm.bulkActions.checkedAll;
                    }
                }
                else {
                    var expense = vm.expenses[index];
                    expense.checked = !expense.checked;
                    
                    if (!expense.checked) {
                        vm.bulkActions.checkedAll = false;
                    }
                }
            }

            function applyBulkAction() {
                // TODO: validate action for all selected before applying
                var selectedExpenses = vm.expenses.filter(expense => expense.checked);
                var isValidSelection = false;
                var action = null;

                switch (vm.bulkActions.selected && vm.bulkActions.selected.id) {
                    case bulkActionsEnum.PAY:
                        action = 'pay';
                        isValidSelection = !selectedExpenses.filter(expense => expense.payment_date).length;
                        break;
                    case bulkActionsEnum.REVERSE:
                        action = 'reverse';
                        isValidSelection = !selectedExpenses.filter(expense => !expense.payment_date).length;
                        break;
                    case bulkActionsEnum.DELETE:
                        action = 'remove';
                        isValidSelection = !selectedExpenses.filter(expense => expense.payment_date).length;
                        break;
                    default:
                        // do nothing;
                        break;
                }

                if (!action) {
                    alertify.alert(
                        'Bulk action',
                        'You must select an action from the drop-down list before applying');
                }
                else if (!selectedExpenses.length)  {
                    alertify.alert(
                        'Bulk action',
                        'You must select at least one expense from the listing below');
                } 
                else if (!isValidSelection)  {
                    alertify.alert(
                        'Bulk action',
                        'The operation can not be performed on all selected expenses.<br>No action was taken.<br><br>Please review the selected expenses and try again.');
                }
                else {
                    vm[action](selectedExpenses.map(expense => expense.id));
                }
            }

            function qboImport() {
                if (vm.qboImporting) {
                    return
                }

                vm.qboImporting = true;
                
                ExpensesService.qboImport()
                .then(() => toastr.success('Quick Books data successfully imported'))
                .catch(() => toastr.error('Something went wrong. Please try again later'))
                .finally(() => view.refresh());
            }
        }
     
        function save() {
            // TODO: better visual feedback
            // FIXME: not using angularjs validation due to date picker component no working properly
            vm.form_error = true;
            if (!vm.expense.due_date || !moment(vm.expense.due_date).isValid()
                || !vm.expense.currency) {
                return;
            }
            if (vm.paid && (
                !vm.expense.payment_date || !moment(vm.expense.payment_date).isValid()
                || !vm.expense.account)) {
                return;
            } 
            if (vm.recurring 
                && vm.expense.recurringDueDates
                .filter(date => !date || !moment(date).isValid()).length) {
                return;
            }
            if (isNaN(Number(vm.expense.additions))
            || isNaN(Number(vm.expense.discounts))) {
                return;
            }
            if (!vm.expense.items || !vm.expense.items.length) {
                return;
            }
            vm.form_error = false;
                
            // TODO: improve this, it is creating another Expense instance on ExpenseService
            var data = vm.expense;
            data.paid = vm.paid; 
            data.recurring = vm.recurring; 
            
            var expensePromise = null;
            
            if (view.currentMethod === 'edit') {
                expensePromise = ExpensesService.updateExpense($state.params.id, data);
            }
            else {
                expensePromise = ExpensesService.createExpense(data);
            }
            
            expensePromise
            .then(expense => {
                toastr.success('Expense successfully saved')
                $state.go('root.expenses.list');
            })
            .catch(() => toastr.error('Something went wrong. Please try again later'))
        }

        function remove(id) { // TODO: consider extracting to service/model
            alertify
                .confirm('Do you really want to delete this expense?<br>This action is irreversible!')
                .set('labels', {
                    ok: 'Yes, delete this expense',
                    cancel: 'No'
                })
                .set('title', 'Delete Expense')
                .set('onok', function () {
                    ExpensesService.deleteExpenseById(id)
                    .then(() => toastr.success('Expense successfully deleted'))
                    .catch(() => toastr.error('Something went wrong. Please try again later'))
                    .finally(() => $state.go('root.expenses.list', $state.params, { reload: true }));
                })
                .show();
        }

        function pay(expense) { // TODO: consider extracting to service/model
            $uibModal.open({
                templateUrl: 'templates/expenses/templates/expenses-payment.html',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var modal = this;

                    /* Bindables */
                    modal.cancel = $uibModalInstance.close;
                    modal.save = save;
                    modal.optionsPaymentDatepicker = {
                        format: "longDate",
                        autoUpdateInput: true,
                        singleDatePicker: true, 
                        showDropdowns: true,
                        maxDate: moment()
                    };
                    modal.paymentMethods = paymentMethods;
                    modal.bankAccounts = bankAccounts;
                    modal.form_error = false; 

                    modal.expense = new Expense(expense);

                    // Workaround due to expense items not being available at this time
                    modal.expense.subtotal = expense.total;
                    modal.expense.updateTotal();
                    
                    /* Implementation details */
                    function save() {
                        var data = {};

                        // TODO: better visual feedback
                        // FIXME: not using angularjs validation due to date picker component no working properly
                        modal.form_error = true;
                        if (!modal.expense.payment_date || !moment(modal.expense.payment_date).isValid()
                            || !modal.expense.account
                            || isNaN(Number(modal.expense.additions))
                            || isNaN(Number(modal.expense.discounts))) {
                            return;
                        }
                        modal.form_error = false;

                        data.payment_date = modal.expense.payment_date;
                        data.payment_method_id = modal.expense.payment_method && modal.expense.payment_method.id;
                        data.account_id = modal.expense.account.id;
                        data.additions = modal.expense.additions;
                        data.discounts = modal.expense.discounts;
    
                        ExpensesService.payExpenseById(expense, data)
                            .then(() => toastr.success('Expense successfully paid'))
                            .catch(() => toastr.error('Something went wrong. Please try again later'))
                            .finally(() => {
                                modal.cancel();
                                view.refresh();
                            });
                    }
                }],
                controllerAs: 'modal',
            });
        }

        function reverse(id) {
            // TODO: these defaults can't be changed here: they affect the entire app
            // alertify.defaults.transition = 'slide';
            // alertify.defaults.theme.input = 'form-control';
            // alertify.defaults.theme.ok = 'btn btn-primary';
            // alertify.defaults.theme.cancel = 'btn btn-default';
            
            alertify
                .confirm('Do you really want to reverse this expense payment?')
                .set('labels', {
                    ok: 'Yes, reverse this payment',
                    cancel: 'No'
                })
                .set('title', 'Reverse Payment')
                .set('onok', function () {
                    ExpensesService.reverseExpenseById(id)
                    .then(() => toastr.success('Expense successfully reversed'))
                    .catch(() => toastr.error('Something went wrong. Please try again later'))
                    .finally(() => view.refresh());
                })
                .show();
        } 
    }
})();